import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import {
  GooogleAnalyticsCategoryType,
  GooogleAnalyticsActionType,
} from '../../models/types/';
const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID ?? '';
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID ?? '';
const InitializeGoogleAnalytics = () => {
  // Initialize UA
  ReactGA.initialize(TRACKING_ID);
  // Initialize GA4 - Add your measurement ID
  ReactGA4.initialize(MEASUREMENT_ID);
};

const TrackGoogleAnalyticsEvent = (
  action: GooogleAnalyticsActionType,
  category: GooogleAnalyticsCategoryType,
  label: string
) => {
  // Send GA4 Event
  ReactGA4.event({
    category: category,
    action: action,
    label: label,
  });
};
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
